export default {
  allVariations: [],
  relatedVariationData: [],
  variationsActive: false,
  listingVariationGroupCombos: [],
  variationFilterQueryStringVar: '',
  activeVariationFilters: [],
  variationRecordsUsed: [],
  productVariationInfoData: []
}
